export default __webpack_public_path__ + "static/media/photo10.3d5ca6ba.jpg";